import { authHeader, handleResponse } from "../helpers";
export const dealerService = {
  createDealer,
  fetchStateDLL,
  fetchCityDLL,
  fetchFirmDLL,
  updateDealer,
  updateContractor,
  fetchDealerData,
  fetchDealerDatatoApprove,
  inActiveRow,
  updatePaymentStatus,
  //fetchRoleDLL,
  fetchTransportationModeDDL,
  fetchDealerDataforExport,
  fetchDistrictDLL,
  fetchDStateDLL,
  fetchDCityDLL,
  fetchDCityDLL2,
  GETPAYMENTDDL,
  GETDOCUMENTTYPEDDL ,GetSalesPersonDDL
};

async function createDealer(data) {
  console.log(data);
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/CreateDealer`,
    requestOptions
  );
  return handleResponse(response);
}

async function updateDealer(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/UpdateDealer`,
    requestOptions
  );
  return handleResponse(response);
}

async function updateContractor(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/UpdateDealerUserApprovalContractor`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchStateDLL(countryId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetStateDLL/${countryId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDStateDLL(countryId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetStateDLL/${countryId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchCityDLL(userId) {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL/${userId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDCityDLL(userId) {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL/${userId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDCityDLL2() {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL2`,
    requestOptions
  );
  return handleResponse(response);
}
async function fetchDistrictDLL(userId) {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDistrictDDL/${userId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchFirmDLL() { 

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}UserReg/GetCompanyDDl`,
    requestOptions
  );
  return handleResponse(response);
}

async function GETPAYMENTDDL() {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}UserReg/GetPyamnetTypeDDl`,
    requestOptions
  );
  return handleResponse(response);
}
 
async function GETDOCUMENTTYPEDDL() {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}List/GetListDataForDDL?id=1`,
    requestOptions
  );
  return handleResponse(response);
}


async function GetSalesPersonDDL() {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}UserdMaster/GetAllSalesPersonDDL`,
    requestOptions
  );
  return handleResponse(response);
}
// async function fetchRoleDLL(userId) {
//   const requestOptions = {
//       method: 'GET',
//       headers: authHeader()
//   };

//   const response = await fetch(`${process.env.REACT_APP_API_URL}RoleMaster/GetRoleDLL/${2}`, requestOptions);
//   return handleResponse(response);
// }

async function fetchTransportationModeDDL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetTransportationModeDLL`,
    requestOptions
  );
  return handleResponse(response);
}


async function fetchDealerData(data) {
  
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDealers`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDealerDatatoApprove(data) {
  
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDealerstoApprove`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDealerDataforExport(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDealers`,
    requestOptions
  );
  return handleResponse(response);
}

async function inActiveRow(UserId, isActive) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/InActiveRow/${UserId}/${isActive}`,
    requestOptions
  );
  return handleResponse(response);
}

export async function updatePaymentStatus(userId, isPayment) {
  
  const requestOptions = {
    method: "GET", // ❗️ ideally should be POST or PUT for updates
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/UpdatePaymentStatus/${userId}`,
    requestOptions
  );

  return handleResponse(response);
}

